/**
 * @fileoverview Contact Categories settings page (MOR-914)
 *
 * URL: /dashboard/firm-contacts/categories
 *
 * Manager for user-defined firm-contact categories (name, colour, icon,
 * description). Shares the grey settings canvas with the Contact Fields
 * page for visual consistency.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { useActiveOrg } from "@/utils/org-context";
import { FirmContactCategoriesManager } from "@/components/firm-contacts/FirmContactCategoriesManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/firm-contacts/categories",
)({
  component: ContactCategoriesPage,
  beforeLoad: () => ({
    title: "Contact Categories",
    headerTitle: "Firm Contacts",
  }),
});

function ContactCategoriesPage() {
  const { activeOrg, isLoading } = useActiveOrg();

  if (isLoading) {
    return (
      <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!activeOrg) {
    throw redirect({ to: "/dashboard" });
  }

  const canEdit = activeOrg.role === "owner" || activeOrg.role === "admin";

  return (
    <div className="flex h-full w-full flex-col bg-muted">
      <div className="mx-auto flex w-full max-w-screen-xl flex-1 flex-col p-6">
        <FirmContactCategoriesManager orgId={activeOrg._id} canEdit={canEdit} />
      </div>
    </div>
  );
}
